import { getExceptionsFromHolidays } from 'utils/holidays';
export function getDeletedHolidays({ holidays, exceptions, agentName, }) {
    const exceptionHolidayIds = exceptions.reduce((acc, { opening_hour_type, recurring }) => {
        const isHoliday = opening_hour_type === 'holiday' && (recurring === null || recurring === void 0 ? void 0 : recurring.holiday);
        return isHoliday ? [...acc, recurring.holiday] : acc;
    }, []);
    const deletedHolidays = holidays.filter(({ id: holidayId }) => !exceptionHolidayIds.includes(holidayId));
    return getExceptionsFromHolidays({
        agentName,
        holidays: deletedHolidays,
        isClosed: true,
    });
}
